document.addEventListener("DOMContentLoaded", () => {

    function initCharmFilters() {

        const list = document.querySelector(".charm_bar__collection-list");
        if (!list) return false;

        const originalRows = list.querySelectorAll(".charm_bar__collection-item");
        if (!originalRows.length) return false;

        if (document.querySelector(".builder-filter-container")) return true;

        const categories = new Set();
        const sizes = new Set();
        const colours = new Set();

        const categoryOrder = [];
        const grouped = new Map();

        const preferredOrder = ["Delicate", "Standard", "Statement"];
        const preferredColourOrder = ["Gold", "Silver"];

        /* =====================================================
           PARSE + GROUP ROWS BY CATEGORY
           Title format: "{Size} - {Category} - {Colour}"
           e.g. "Delicate - Sea Creatures - Gold"
        ===================================================== */

        originalRows.forEach(row => {

            const h3 = row.querySelector("h3");
            if (!h3) return;

            const original = h3.textContent.trim();
            const parts = original.split(/[-—]/).map(p => p.trim());

            let size = "";
            let category = "";
            let colour = "";

            if (parts.length >= 3) {
                size = parts[0];
                category = parts[1];
                colour = parts[2];
            } else if (parts.length === 2) {
                size = parts[0];
                category = parts[1];
            } else {
                category = original;
            }

            const catKey = category.toLowerCase();

            if (!grouped.has(catKey)) {
                grouped.set(catKey, {
                    label: category,
                    rows: []
                });

                categoryOrder.push(catKey);
            }

            const charmList = row.querySelector(
                ".charm_bar__charm-items-list"
            );

            const count = charmList
                ? charmList.querySelectorAll(".charm_bar__charm-item").length
                : 0;

            grouped.get(catKey).rows.push({
                size,
                colour,
                count,
                listEl: charmList,
                originalRow: row,
            });

            if (category) categories.add(category);
            if (size) sizes.add(size);
            if (colour) colours.add(colour);

        });

        /* =====================================================
           BUILD ONE PARENT BOX PER CATEGORY
        ===================================================== */

        categoryOrder.forEach(catKey => {

            const group = grouped.get(catKey);

            group.rows.sort((a, b) => {

                const ai = preferredOrder.indexOf(a.size);
                const bi = preferredOrder.indexOf(b.size);

                if (ai === -1 && bi === -1) {
                    return a.size.localeCompare(b.size);
                }

                if (ai === -1) return 1;
                if (bi === -1) return -1;

                return ai - bi;

            });

            const totalCount = group.rows.reduce(
                (sum, r) => sum + r.count,
                0
            );

            const parent = document.createElement("div");

            parent.className =
                "charm_bar__collection-item charm-category-parent";

            parent.dataset.category = catKey;

            const h3 = document.createElement("h3");

            h3.innerHTML = `
                <span class="accordion-title">

                    <span class="accordion-title-main">
                        <span class="charm-category-label">
                            ${group.label}
                        </span>
                    </span>

                    <span class="accordion-title-meta">
                        <span class="charm-count">
                            ${totalCount}
                        </span>
                    </span>

                </span>
            `;

            parent.appendChild(h3);

            const groupsWrapper = document.createElement("div");
            groupsWrapper.className = "charm-size-groups-wrapper";

            group.rows.forEach(r => {

                const sizeGroup = document.createElement("div");

                sizeGroup.className = "charm-size-group";

                sizeGroup.dataset.size =
                    r.size.toLowerCase();

                sizeGroup.dataset.colour =
                    r.colour.toLowerCase();

                if (r.size) {

                    const heading = document.createElement("div");

                    heading.className =
                        `charm-size-heading charm-size-tag--${r.size.toLowerCase()}`;

                    heading.innerHTML =
                        `${r.size} <span class="charm-size-heading-count">(${r.count})</span>`;

                    sizeGroup.appendChild(heading);

                }

                if (r.listEl) {
                    sizeGroup.appendChild(r.listEl);
                }

                groupsWrapper.appendChild(sizeGroup);

            });

            parent.appendChild(groupsWrapper);

            const firstRow = group.rows[0].originalRow;

            firstRow.parentNode.insertBefore(
                parent,
                firstRow
            );

            group.rows.forEach(
                r => r.originalRow.remove()
            );

        });

        const parents =
            list.querySelectorAll(".charm-category-parent");

        /* =====================================================
           FILTER CONTROLS
        ===================================================== */

        const container = document.createElement("div");
        container.className = "builder-filter-container";

        const filterRow = document.createElement("div");
        filterRow.className = "builder-filter-row";

        container.appendChild(filterRow);

        const charmsTitle = [...list.querySelectorAll("h2")]
            .find(h =>
                h.textContent.toLowerCase().includes("charms")
            );

        if (charmsTitle) {

            const charmsIntro =
                charmsTitle.nextElementSibling;

            if (
                charmsIntro &&
                charmsIntro.tagName === "P"
            ) {

                charmsIntro.insertAdjacentElement(
                    "afterend",
                    container
                );

            } else {

                charmsTitle.insertAdjacentElement(
                    "afterend",
                    container
                );

            }

        } else {

            list.prepend(container);

        }

 

 /* =====================================================
   FILTER DROPDOWNS
===================================================== */

function createSelect(id, defaultLabel, values, preferredOrder = []) {

    const wrap = document.createElement("div");
    wrap.className = "builder-filter-select";

    const select = document.createElement("select");
    select.id = id;

    select.innerHTML = `
        <option value="all">${defaultLabel}</option>
    `;

    const ordered = [...values].sort((a, b) => {

        const ai = preferredOrder.indexOf(a);
        const bi = preferredOrder.indexOf(b);

        if (ai === -1 && bi === -1) {
            return a.localeCompare(b);
        }

        if (ai === -1) return 1;
        if (bi === -1) return -1;

        return ai - bi;
    });

    ordered.forEach(value => {

        const option = document.createElement("option");

        option.value = value.toLowerCase();
        option.textContent = value;

        select.appendChild(option);
    });

    wrap.appendChild(select);

    return {
        wrap,
        select
    };
}


/* Collection */

const categoryFilter = createSelect(
    "charm-category-select",
    "All Collections",
    categories
);


/* Colour */

const colourFilter = createSelect(
    "charm-colour-select",
    "All Colours",
    colours,
    ["Gold", "Silver"]
);


/* Size */

const sizeFilter = createSelect(
    "charm-size-select",
    "All Sizes",
    sizes,
    ["Delicate", "Standard", "Statement"]
);


filterRow.appendChild(categoryFilter.wrap);
filterRow.appendChild(colourFilter.wrap);
filterRow.appendChild(sizeFilter.wrap);


/* =====================================================
   ACTIVE FILTERS
===================================================== */

let activeCategory = "all";
let activeColour = "all";
let activeSize = "all";


/* =====================================================
   APPLY FILTERS
===================================================== */

function applyFilters() {

    let firstVisibleParent = null;

    parents.forEach(parent => {

        const matchesCategory =
            activeCategory === "all" ||
            parent.dataset.category === activeCategory;

        let hasVisibleGroup = false;

        parent
            .querySelectorAll(".charm-size-group")
            .forEach(group => {

                const matchesSize =
                    activeSize === "all" ||
                    group.dataset.size === activeSize;

                const matchesColour =
                    activeColour === "all" ||
                    group.dataset.colour === activeColour;

                const visible =
                    matchesSize && matchesColour;

                group.style.display =
                    visible ? "" : "none";

                if (visible) {
                    hasVisibleGroup = true;
                }

            });

        const showParent =
            matchesCategory && hasVisibleGroup;

        parent.style.display =
            showParent ? "" : "none";

        /*
         Don't change accordion open/closed state
         when changing a filter.
        */

        if (
            showParent &&
            !firstVisibleParent
        ) {
            firstVisibleParent = parent;
        }

    });

}


/* =====================================================
   FILTER EVENTS
===================================================== */

categoryFilter.select.addEventListener("change", () => {

    activeCategory =
        categoryFilter.select.value;

    applyFilters();

});


colourFilter.select.addEventListener("change", () => {

    activeColour =
        colourFilter.select.value;

    applyFilters();

});


sizeFilter.select.addEventListener("change", () => {

    activeSize =
        sizeFilter.select.value;

    applyFilters();

});


applyFilters();



        requestAnimationFrame(() => {
            list.classList.add("builder-ready");
        });

        return true;

    }

    let tries = 0;

    const wait = setInterval(() => {

        if (initCharmFilters()) {
            clearInterval(wait);
        }

        if (++tries > 40) {
            clearInterval(wait);
        }

    }, 300);

});

/* =====================================================
   CHARM COLLECTION ACCORDIONS
===================================================== */

document.addEventListener("click", e => {

    const heading = e.target.closest(
        ".charm-category-parent > h3"
    );

    if (!heading) return;

    const section = heading.closest(
        ".charm-category-parent"
    );

    if (!section) return;

    const isOpen = section.classList.contains("open");

    /* Close the other accordions */
    document
        .querySelectorAll(".charm-category-parent.open")
        .forEach(item => {

            if (item !== section) {
                item.classList.remove("open");
            }

        });

    /* Toggle clicked accordion */
    section.classList.toggle("open", !isOpen);

});